<div class="asignaciones-my-assignments">
  <button
    type="button"
    class="btn-assignments"
    (click)="toggle($event)"
    [attr.aria-expanded]="open()"
    aria-label="Mis asignaciones">
    <mat-icon svgIcon="mat:assignment_ind"></mat-icon>
    <span class="badge" *ngIf="pendingCount > 0">{{ pendingCount > 99 ? '99+' : pendingCount }}</span>
  </button>

  <div class="dropdown" *ngIf="open()">
    <div class="dropdown-header">
      <span class="dropdown-title">Mis asignaciones</span>
      <button type="button" class="btn-view-all" (click)="viewAll($event)">Ver tablero</button>
    </div>

    <div class="dropdown-body">
      <p class="dropdown-empty" *ngIf="loading()">Cargando...</p>
      <p class="dropdown-empty" *ngIf="!loading() && !tickets().length">
        No tienes tickets pendientes o en curso
      </p>

      <button
        type="button"
        class="assignment-item"
        *ngFor="let t of tickets()"
        (click)="openTicket(t, $event)">
        <div class="assignment-item-top">
          <span class="assignment-id">SIS-{{ t.id }}</span>
          <span class="status-lozenge" [attr.data-status]="t.status">{{ statusLabels[t.status] }}</span>
        </div>
        <span class="assignment-title">{{ t.title }}</span>
        <div class="assignment-meta">
          <span class="type-badge" [style.background-color]="typeDisplay(t).color">
            <mat-icon class="type-icon" [svgIcon]="typeDisplay(t).icon"></mat-icon>
            {{ typeDisplay(t).label }}
          </span>
          <mat-icon
            class="priority-icon"
            [svgIcon]="priorityIcons[t.priority || 'medio']"
            [attr.data-priority]="t.priority || 'medio'"
            [title]="priorityLabels[t.priority || 'medio']">
          </mat-icon>
          <app-asignaciones-mr-icon [ticket]="t" [clickable]="false"></app-asignaciones-mr-icon>
          <span *ngIf="t.storyPoints != null" class="sp-badge">{{ t.storyPoints }} SP</span>
        </div>
      </button>
    </div>
  </div>
</div>
